const util = {
  formatTime: (date, type) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    switch (type) {
      case 'yyyy-MM-dd':
        return [year, month, day].map(formatNumber).join('-')
      case 'yyyy-MM-dd hh:mm':
        return `${year}年${month}月${day}日 ${hour}时${minute}分`
      // return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
      case 'yyyy.MM.dd hh:mm':
        return (
          [year, month, day].map(formatNumber).join('.') +
          ' ' +
          [hour, minute].map(formatNumber).join(':')
        )
      case 'MM.dd hh:mm':
        return (
          [month, day].map(formatNumber).join('.') +
          ' ' +
          [hour, minute].map(formatNumber).join(':')
        )
      case '时分秒':
        return `${month}月${day}日 ${hour}时${minute}分`
      case 'yyyy-MM-dd hh:mm:ss':
        return (
          [year, month, day].map(formatNumber).join('-') +
          ' ' +
          [hour, minute, second].map(formatNumber).join(':')
        )
      default:
        return (
          [year, month, day].map(formatNumber).join('-') +
          ' ' +
          [hour, minute, second].map(formatNumber).join(':')
        )
    }
  },

  yearStr: (date, type)=>{
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    switch (type) {
      case 'yyyy-MM-dd':
        // return `${year}年${month}月${day}日 ${hour}时${minute}分`
        return `${year}年${month}月${day}日`
      default:
        return (
          [year, month, day].map(formatNumber).join('-') +
          ' ' +
          [hour, minute, second].map(formatNumber).join(':')
        )
    }
  },

  filerDate (t) {
    let toDou = n => (n < 10 ? `0${n}` : `${n}`)
    let oDate = new Date(t)
    return `${oDate.getFullYear()}年${toDou(oDate.getMonth() + 1)}月${toDou(
      oDate.getDate()
    )}日`
  },

  formatDateTime (inputTime) {
    var date = new Date(inputTime)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    var h = date.getHours()
    h = h < 10 ? '0' + h : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    // return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second;
    return y + '年' + m + '月' + d + '日 ' + h + ':' + minute
  },

  formatTime2: (date, type) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    switch (type) {
      case 'MM-dd':
        return [month, day].map(formatNumber).join('-')
      default:
        return (
          [month, day].map(formatNumber).join('-') +
          ' ' +
          [hour, minute, second].map(formatNumber).join(':')
        )
    }
  },

  keyScroll () {
    window.scrollTo(0, 0)
  },

  dateFomatLine: (date = new Date()) => {
    return (
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    )
  },

  getTime(time) {
    let date = new Date(time);
    let toDou = n => (n < 10 ? `0${n}` : `${n}`);

    return `${toDou(date.getHours())}:${toDou(date.getMinutes())}`;
  },
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// module.exports = util;
export default util
